/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AddIcon = /*#__PURE__*/ createSvgIcon(
  'AddIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.25 10.75h-3.5a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h3.5v-3.5c0-.213.071-.39.214-.534A.72.72 0 019.996 5c.21 0 .39.072.535.216a.72.72 0 01.219.534v3.5h3.5c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-3.5v3.5c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534v-3.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AddIcon;
